import { render } from "./BelongsToField.vue?vue&type=template&id=5437c590"
import script from "./BelongsToField.vue?vue&type=script&lang=js"
export * from "./BelongsToField.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BelongsToField.vue"]])

export default __exports__